const dashboard = {
  adminDashboard: 'एडमिन डैशबोर्ड',
  adminSubtitle: 'विशेष स्कूल प्रबंधन और निगरानी',
  therapistDashboard: 'थेरेपिस्ट डैशबोर्ड',
  therapistSubtitle: 'केसलोड, सत्र और प्रगति ट्रैकिंग',
  teacherDashboard: 'शिक्षक डैशबोर्ड',
  teacherSubtitle: 'कक्षा प्रबंधन, पाठ और छात्र ट्रैकिंग',
  pendingApprovals: 'लंबित स्वीकृतियाँ',
  newEnrolments: 'नए नामांकन',
  attendanceRecorded: 'आज की उपस्थिति दर्ज — सभी सुविधाएं अनलॉक।',
  reviewApprovals: 'स्वीकृतियाँ देखें',
  reports: 'रिपोर्ट',
  newSessionNote: 'नया सत्र नोट',
  startAssessment: 'आकलन शुरू करें',
  newLessonPlan: 'नई पाठ योजना',
  markAttendance: 'उपस्थिति दर्ज करें',
  checkInTitle: 'अपना दिन शुरू करने के लिए तैयार?',
  checkInDescription: 'अपनी उपस्थिति दर्ज करने और पूर्ण सिस्टम एक्सेस अनलॉक करने के लिए चेक इन करें।',
  capturingLocation: 'आपका स्थान कैप्चर हो रहा है...',
  checkInNow: 'अभी चेक इन करें',
  checkingIn: 'चेक इन हो रहा है…',
  checkedInTitle: 'आपने चेक इन कर लिया है!',
  checkedInAt: 'चेक इन का समय',
  dontForget: 'जाते समय चेक आउट करना न भूलें।',
  checkOut: 'चेक आउट',
  dayComplete: 'दिन पूरा!',
  checkedOutAt: 'चेक आउट का समय',
  seeYouTomorrow: 'कल मिलते हैं!',
  checkInToContinue: 'जारी रखने के लिए चेक इन करें',
  checkInGateDescription: 'पूर्ण डैशबोर्ड, छात्र रिकॉर्ड और सभी सिस्टम सुविधाओं तक पहुंचने के लिए कृपया ऊपर अपनी दैनिक चेक-इन पूरी करें।',
  activityFeed: 'गतिविधि फ़ीड',
  livePlatformEvents: 'लाइव प्लेटफ़ॉर्म इवेंट',
  weeklyAttendanceTrend: 'साप्ताहिक उपस्थिति रुझान',
  past7Days: 'पिछले 7 दिन',
  avgPresent: 'औसत',
  presentPct: 'उपस्थित',
  present: 'उपस्थित',
  absent: 'अनुपस्थित',
  avgDailyPresent: 'औसत दैनिक उपस्थिति:',
  viewFullAttendance: 'पूर्ण उपस्थिति देखें',
  myCaseload: 'मेरा केसलोड',
  activeStudents: '{{count}} सक्रिय छात्र',
  goalProgress: 'लक्ष्य प्रगति',
  myStudents: 'मेरे छात्र',
  searchStudents: 'छात्र खोजें...',
  classProgress: 'कक्षा प्रगति',
  nextSession: 'अगला',
  pageOf: 'पृष्ठ {{current}} / {{total}}',
  prevPage: 'पिछला',
  nextPage: 'अगला',
  noStudentsMatch: 'कोई छात्र आपकी खोज से मेल नहीं खाता।',
  // Student activity menu
  studentMenuTitle: '{{name}} — त्वरित क्रियाएं',
  caseHistory: 'केस इतिहास',
  caseHistoryDesc: 'चिकित्सा और विकासात्मक पृष्ठभूमि देखें',
  assessment: 'आकलन',
  assessmentDesc: 'छात्र आकलन करें या समीक्षा करें',
  goalsLessonPlan: 'लक्ष्य और पाठ योजना',
  goalsLessonPlanDesc: 'IEP लक्ष्य और पाठ योजना प्रबंधित करें',
  progressReport: 'प्रगति रिपोर्ट',
  progressReportDesc: 'प्रगति रिपोर्ट बनाएं या देखें',
  documents: 'दस्तावेज़',
  documentsDesc: 'अपलोड की गई फ़ाइलें, वर्कशीट और संसाधन',
  parentDiary: 'अभिभावक डायरी',
  parentDiaryDesc: 'अभिभावकों के साथ दैनिक संवाद लॉग',
  multiDomainProgress: 'बहु-डोमेन प्रगति',
  progressSubtitle: 'सभी डोमेन में वर्तमान बनाम बेसलाइन आकलन स्कोर',
  subjectProgress: 'विषय प्रगति',
  subjectProgressSubtitle: 'सभी विषयों में वर्तमान बनाम बेसलाइन स्कोर',
  baseline: 'बेसलाइन',
  current: 'वर्तमान',
  pts: 'अंक',
  goal80: '80% लक्ष्य',
  recentSessionNotes: 'हाल के सत्र नोट्स',
  notesNeedFollowUp: '{{total}} नोट्स — {{challenging}} को फ़ॉलो-अप चाहिए',
  recentLessonNotes: 'हाल के पाठ नोट्स',
  lessonNotesSubtitle: '{{total}} नोट्स — {{challenging}} पर ध्यान चाहिए',
  newNote: 'नया नोट',
  positive: 'सकारात्मक',
  neutral: 'तटस्थ',
  challenging: 'चुनौतीपूर्ण',
  markReviewed: 'समीक्षित चिह्नित करें',
  todaysSchedule: "आज का शेड्यूल",
  sessionsCount: '{{count}} सत्र',
  noSessionsToday: 'आज कोई सत्र नहीं',
  todaysLessons: 'आज के पाठ',
  lessonsCount: '{{count}} पाठ',
  noLessonsToday: 'आज कोई पाठ नहीं',
  facultyManagement: 'शिक्षक प्रबंधन',
  facultySubtitle: 'शिक्षकों, थेरेपिस्ट और सहायक स्टाफ़ का प्रबंधन करें',
  activeFaculty: 'सक्रिय शिक्षक',
  onLeave: 'छुट्टी पर',
  addTeacher: 'शिक्षक जोड़ें',
  noTeachersFound: 'कोई शिक्षक नहीं मिला',
  totalStudents: 'कुल छात्र',
  activeTherapists: 'सक्रिय थेरेपिस्ट',
  sessionsThisWeek: 'इस सप्ताह के सत्र',
  pendingFollowUps: 'लंबित फ़ॉलो-अप',
  totalSessions: 'कुल सत्र',
  totalLessons: 'कुल पाठ',
  orgLessonPlans: 'पाठ योजनाएं',
  pendingNotes: 'लंबित नोट्स',
  avgAttendance: 'औसत उपस्थिति',
  avgProgress: 'औसत प्रगति',
  goalsAchieved: 'लक्ष्य प्राप्त',
  // Sidebar nav items
  caseload: 'केसलोड',
  studentsAttendance: 'छात्र उपस्थिति',
  staffAttendance: 'स्टाफ़ उपस्थिति',
  sessions: 'सत्र',
  assessments: 'आकलन',
  progress: 'प्रगति',
  approvals: 'स्वीकृतियाँ',
  reports: 'रिपोर्ट',
  myChild: 'मेरा बच्चा',
  appointments: 'अपॉइंटमेंट',
  resources: 'संसाधन',
  accessControl: 'पहुंच नियंत्रण',
  facultyManagement: 'शिक्षक प्रबंधन',
  // Incident tracking
  unresolvedIncidentsTitle: '{{count}} अनसुलझी घटना(एं) पर ध्यान चाहिए',
  unresolvedIncidentsDesc: 'कुल {{total}} में से {{unresolved}} घटनाओं पर फ़ॉलो-अप ज़रूरी है। समीक्षा करें और कार्रवाई करें।',
  reviewIncidents: 'घटनाओं की समीक्षा करें',
  incidentsTracked: 'ट्रैक की गई घटनाएं',
  unresolvedCount: '{{count}} अनसुलझी',
  allResolved: 'सभी सुलझ गईं',
  // Announcements
  announcements: 'घोषणाएं',
  announcementsSubtitle: 'शिक्षकों और अभिभावकों को संदेश प्रसारित करें',
  createAnnouncement: 'घोषणा बनाएं',
  newAnnouncement: 'नई घोषणा',
  publishAnnouncement: 'घोषणा प्रकाशित करें',
  publishing: 'प्रकाशित हो रहा है...',
  announcementMessage: 'घोषणा संदेश',
  messagePlaceholder: 'अपना घोषणा संदेश यहां टाइप करें...',
  recordAudio: 'ऑडियो रिकॉर्ड करें',
  stopRecording: 'रिकॉर्डिंग रोकें',
  recordingAudio: 'रिकॉर्डिंग हो रही है...',
  audioRecorded: 'ऑडियो संदेश रिकॉर्ड किया गया',
  selectFaculty: 'शिक्षक चुनें',
  selectParents: 'अभिभावक चुनें',
  selectAll: 'सभी चुनें',
  unselectAll: 'सभी हटाएं',
  selectedCount: '{{count}} चयनित',
  scheduleFor: 'के लिए शेड्यूल करें',
  publishNow: 'अभी प्रकाशित करें',
  scheduleLater: 'बाद के लिए शेड्यूल करें',
  noAnnouncements: 'अभी तक कोई घोषणा नहीं',
  noAnnouncementsDesc: 'आपके द्वारा बनाई गई घोषणाएं यहां दिखाई देंगी।',
  searchAnnouncements: 'घोषणाएं खोजें...',
  allAnnouncements: 'सभी घोषणाएं',
  filterByDate: 'तारीख के अनुसार फ़िल्टर करें',
  sentTo: 'भेजा गया',
  allFaculty: 'सभी शिक्षक',
  allParents: 'सभी अभिभावक',
  selectedFaculty: '{{count}} शिक्षक',
  selectedParents: '{{count}} अभिभावक',
  noRecipients: 'कोई प्राप्तकर्ता नहीं चुना गया',
  publishedBy: 'द्वारा प्रकाशित',
  scheduled: 'शेड्यूल्ड',
  published: 'प्रकाशित',
  onDate: 'को',
  announcementCreated: 'घोषणा सफलतापूर्वक प्रकाशित!',
  announcementScheduled: 'घोषणा सफलतापूर्वक शेड्यूल!',
  messageRequired: 'संदेश आवश्यक है',
  recipientsRequired: 'कृपया कम से कम एक प्राप्तकर्ता समूह चुनें',
  facultyAndParents: 'शिक्षक और अभिभावक',
  facultyOnly: 'केवल शिक्षक',
  parentsOnly: 'केवल अभिभावक',
  audioMessageAttached: 'ऑडियो संदेश संलग्न',
  deleteAnnouncement: 'घोषणा हटाएं',
  deleteAnnouncementConfirm: 'क्या आप वाकई इस घोषणा को हटाना चाहते हैं?',
  announcementDeleted: 'घोषणा हटा दी गई',
  clearDateFilter: 'तारीख फ़िल्टर हटाएं',
  todayAnnouncements: 'आज की घोषणाएं',
  upcomingAnnouncements: 'आगामी घोषणाएं',
  previousAnnouncements: 'पिछली घोषणाएं',
  noTodayAnnouncements: 'आज कोई घोषणा प्रकाशित नहीं हुई',
  noTodayAnnouncementsDesc: 'आज प्रकाशित घोषणाएं यहां दिखाई देंगी।',
  noUpcomingAnnouncements: 'कोई आगामी घोषणा शेड्यूल नहीं है',
  noUpcomingAnnouncementsDesc: 'भविष्य की तिथियों के लिए शेड्यूल की गई घोषणाएं इस टैब में दिखाई देंगी।',
  noPreviousAnnouncements: 'कोई पिछली घोषणा नहीं',
  noPreviousAnnouncementsDesc: 'प्रकाशन तिथि बीत जाने के बाद पिछली घोषणाएं यहां दिखाई देंगी।',
  byLabel: 'द्वारा',
  audioAnnouncement: 'ऑडियो घोषणा',
  playAudio: 'ऑडियो चलाएं',
  pauseAudio: 'ऑडियो रोकें',
  selectedRecipients: 'चयनित प्राप्तकर्ता',
  noFacultySelected: 'कोई शिक्षक नहीं चुना गया',
  noParentsSelected: 'कोई अभिभावक नहीं चुना गया',
  scheduleDateTime: 'शेड्यूल तिथि और समय',
  // Read status
  markAsRead: 'पढ़ा हुआ चिह्नित करें',
  read: 'पढ़ा हुआ',
  unread: 'नहीं पढ़ा',
  // School Calendar
  schoolCalendar: 'स्कूल कैलेंडर',
  schoolCalendarSubtitle: 'एकीकृत कैलेंडर — कार्यक्रम, छुट्टियाँ और कार्य',
  calendarView: 'कैलेंडर दृश्य',
  listView: 'सूची दृश्य',
  goToToday: 'आज',
  previousMonth: 'पिछला महीना',
  nextMonth: 'अगला महीना',
  selectDate: 'तारीख चुनें',
  globalEvents: 'वैश्विक जागरूकता दिवस',
  schoolHolidays: 'स्कूल की छुट्टियाँ',
  personalTasks: 'मेरे कार्य',
  showGlobalEvents: 'वैश्विक कार्यक्रम दिखाएं',
  showSchoolHolidays: 'स्कूल की छुट्टियाँ दिखाएं',
  showPersonalTasks: 'मेरे कार्य दिखाएं',
  addTask: 'कार्य जोड़ें',
  addNewTask: 'नया कार्य जोड़ें',
  taskTitle: 'कार्य का शीर्षक',
  taskTitlePlaceholder: 'कार्य का शीर्षक दर्ज करें...',
  dueTime: 'नियत समय',
  taskDescription: 'विवरण',
  taskDescriptionPlaceholder: 'संक्षिप्त विवरण जोड़ें...',
  taskCreated: 'कार्य सफलतापूर्वक बनाया गया!',
  taskUpdated: 'कार्य सफलतापूर्वक अपडेट किया गया!',
  taskCompleted: 'कार्य पूर्ण चिह्नित किया गया',
  deleteTask: 'कार्य हटाएं',
  deleteTaskConfirm: 'क्या आप वाकई इस कार्य को हटाना चाहते हैं?',
  noTasksForDate: 'इस तारीख के लिए कोई कार्य नहीं',
  noEventsFound: 'कोई कार्यक्रम नहीं मिला',
  allDay: 'पूरा दिन',
  markComplete: 'पूर्ण चिह्नित करें',
  markIncomplete: 'अपूर्ण चिह्नित करें',
  recurring: 'वार्षिक पुनरावृत्ति',
  holidayNational: 'राष्ट्रीय',
  holidayRegional: 'क्षेत्रीय',
  holidayDiscretionary: 'विवेकाधीन',
  impactsAttendance: 'उपस्थिति को प्रभावित करता है',
  targetAll: 'सभी',
  targetTeachers: 'शिक्षक',
  targetParents: 'अभिभावक',
  // Calendar Settings
  calendarSettings: 'कैलेंडर सेटिंग्स',
  calendarSettingsSubtitle: 'वैश्विक जागरूकता दिवस और स्कूल की छुट्टियाँ प्रबंधित करें',
  awarenessEventsMaster: 'जागरूकता कार्यक्रम मास्टर',
  holidayMaster: 'छुट्टी मास्टर',
  awarenessEventsDescription: 'स्कूल नेटवर्क में मनाए जाने वाले वैश्विक जागरूकता दिवसों को परिभाषित और प्रबंधित करें।',
  holidayMasterDescription: 'शेड्यूलिंग और उपस्थिति गणना को प्रभावित करने वाली स्कूल की छुट्टियों का प्रबंधन करें।',
  addEvent: 'कार्यक्रम जोड़ें',
  addHoliday: 'छुट्टी जोड़ें',
  editEvent: 'कार्यक्रम संपादित करें',
  editHoliday: 'छुट्टी संपादित करें',
  eventName: 'कार्यक्रम का नाम',
  eventDate: 'कार्यक्रम तिथि (DD/MM)',
  isRecurring: 'वार्षिक पुनरावृत्ति',
  targetAudience: 'लक्षित दर्शक',
  eventDescription: 'विवरण',
  holidayTitle: 'छुट्टी का शीर्षक',
  startDate: 'आरंभ तिथि',
  endDate: 'समाप्ति तिथि',
  holidayType: 'छुट्टी का प्रकार',
  impactsAttendanceLabel: 'उपस्थिति गणना को प्रभावित करता है',
  importCsv: 'CSV आयात करें',
  csvImportHint: 'कॉलम के साथ CSV फ़ाइल अपलोड करें: कार्यक्रम का नाम, तिथि (DD/MM), आवर्ती है, लक्षित दर्शक, विवरण',
  noEventsDefined: 'अभी तक कोई जागरूकता कार्यक्रम परिभाषित नहीं है।',
  noHolidaysDefined: 'अभी तक कोई छुट्टी परिभाषित नहीं है।',
  eventCreated: 'कार्यक्रम सफलतापूर्वक बनाया गया!',
  holidayCreated: 'छुट्टी सफलतापूर्वक बनाई गई!',
  eventUpdated: 'कार्यक्रम सफलतापूर्वक अपडेट किया गया!',
  holidayUpdated: 'छुट्टी सफलतापूर्वक अपडेट की गई!',
  eventDeleted: 'कार्यक्रम सफलतापूर्वक हटाया गया!',
  holidayDeleted: 'छुट्टी सफलतापूर्वक हटाई गई!',
  duplicateDateRange: 'यह तिथि सीमा मौजूदा छुट्टी के साथ ओवरलैप करती है',
  noTasksForDay: 'इस दिन के लिए कोई कार्य नहीं',
  completedTasks: 'पूर्ण',
  pendingTasks: 'लंबित',
};

export default dashboard;